import { render, staticRenderFns } from "./uploaddocs.vue?vue&type=template&id=b1e59dc8&scoped=true&"
import script from "./uploaddocs.vue?vue&type=script&lang=js&"
export * from "./uploaddocs.vue?vue&type=script&lang=js&"
import style0 from "./uploaddocs.vue?vue&type=style&index=0&id=b1e59dc8&prod&lang=scss&"
import style1 from "./uploaddocs.vue?vue&type=style&index=1&id=b1e59dc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e59dc8",
  null
  
)

export default component.exports